import { render, staticRenderFns } from "./ChildTableComponent.vue?vue&type=template&id=e8564768&"
import script from "./ChildTableComponent.vue?vue&type=script&lang=js&"
export * from "./ChildTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports